import { CustomerGroupDTO } from './CustomerGroupsDTO';

export type CustomerGroupsValue = string[];

export const mapCustomerGroups = (customerGroupsDTO: CustomerGroupDTO) => {
    return customerGroupsDTO.customerGroups?.map((group) => group.id) || [];
};
